module.exports = __webpack_public_path__ + "media/images/icons/social/twitter-80656dd29f781e4d9a51020efd9504f21bfb695a4fdd532ffbed3f7ccf4d6e77.svg";